module.exports = __webpack_public_path__ + "static/img/矩形top.7308e4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/appDownLoad/pc/矩形top.png
// module id = G6rl
// module chunks = 1